export default __webpack_public_path__ + "static/media/idolofset.18e38166.png";